export var SlideDirection;
(function(SlideDirection) {
    SlideDirection["LEFT"] = "left";
    SlideDirection["RIGHT"] = "right";
})(SlideDirection || (SlideDirection = {}));

//# sourceMappingURL=types.js.map